import * as Yup from 'yup'

const MIDreg = /^\d{15}$/
const IFSCCodereg = /^[A-Z]{4}[A-Z0-9]{7}$/
const Pincodereg = /^[1-9][0-9]{5}$/
const MobileNumberreg = /^\d{10}$/
const OTPreg = /^\d{6}$/
const Passwordreg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/
const CVVreg = /^\d{3}$/
const ExpiryCardreg = /^[0-1][0-9]\/[0-9][0-9]$/
const gstNumberreg = /\d{2}[A-Z]{5}\d{4}[A-Z]{1}[A-Z\d]{1}[Z]{1}[A-Z\d]{1}/
const emailRegex = /^[a-zA-Z0-9_.-]{1,}@[a-z]{1,}.[a-z]{2,}$/
const alphaNumericValidation = /^[a-zA-Z0-9]{8,40}$/


export const name = Yup.string()
  .required('Required')
  .min(3, 'Atleast 3 charecter required')
  .matches(/^[A-Za-z\s]+$/, 'Only characters allowed')

export {
  MIDreg,
  IFSCCodereg,
  Pincodereg,
  MobileNumberreg,
  OTPreg,
  Passwordreg,
  CVVreg,
  ExpiryCardreg,
  gstNumberreg,
  emailRegex,
}

export default alphaNumericValidation
